import React from 'react';
import classnames from 'classnames';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import Overlay from '../../legos/Overlay';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import Timestamp from '../../../../Timestamp';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { StandardThumbProps } from '../types';
import s from './StatusThumb.scss';

const StatusThumb: React.FC<StandardThumbProps> = ({
  className,
  deviation,
  height,
  responsive,
  style,
  width,
  extraActions,
}) => {
  const { showOverlay, __forceHoveredForStories } = useOverlayContext(deviation);
  const canShowTimeStamp = width && width > 150 && height && height > 150;
  return (
    <HoverableWrapper
      className={classnames(s['root'], className)}
      style={{
        width,
        height,
        ...style,
      }}
      __forceHoveredForStories={__forceHoveredForStories}
    >
      <ErrorBoundary debugComponent="StatusThumb">
        <DeviationDumbView
          deviation={deviation}
          width={width}
          height={height}
          responsive={responsive}
        />
        {canShowTimeStamp && (
          <HoverOnly reverseHidden className={s['status-date']}>
            <Timestamp timestamp={deviation.publishedTime || deviation.status?.ts} />
          </HoverOnly>
        )}
        <DeviationLink deviation={deviation} className={s['link-overlay']} title={deviation.title}>
          <span />
        </DeviationLink>
        {showOverlay && (
          <Overlay
            deviation={deviation}
            width={width}
            height={height}
            className={s['overlay']}
            extraActions={extraActions}
          />
        )}
      </ErrorBoundary>
    </HoverableWrapper>
  );
};
StatusThumb.displayName = 'StatusThumb';

export default StatusThumb;
